import React, { FC } from 'react';
import { Accordion, /* Container,*/ ListGroup } from 'react-bootstrap';
import { Action, Button, Icon, Label } from '..';
import styles from './SortableImageBlockItem.module.css';
import cn from 'classnames';
import { BlockType } from '../../../store/landscapeAPI/block/dto/block-type';

export interface BlockItem {
  blockId: string;
  id: string;
  type: BlockType;
  title: string;
  sortOrder: number;
  imageUrl: string | null;
  backgroundImageUrl: string | null;
  backgroundColor: string | null;
  content: string | null;
}

interface SortableImageBlockItemProps {
  id: string;
  changeOrderEnabled: boolean;
  blockItem: BlockItem;
  blockItems: BlockItem[];
  blockItemsLength: number;
  blockItemIndex: number;
  moveListItem: (from: number, to: number) => void;
  handleDelete: (id: string) => void;
  handleEdit: (id: string, type: BlockType) => void;
}

const SortableImageBlockItem: FC<SortableImageBlockItemProps> = ({
  id,
  changeOrderEnabled,
  blockItem,
  blockItems,
  blockItemsLength,
  blockItemIndex,
  moveListItem,
  handleDelete,
  handleEdit,
}) => {
  return (
    <ListGroup.Item>
      <Accordion flush alwaysOpen defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            {' '}
            <Label content={blockItem.title} size="heading-md" />
          </Accordion.Header>
          <Accordion.Body>
            <div className={styles.accordionHeader}>
              <div className={styles.sortActionsWrapper}>
                {changeOrderEnabled &&
                  blockItemsLength > 1 &&
                  blockItemIndex !== 0 && (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        moveListItem(
                          blockItem.sortOrder,
                          blockItems[blockItemIndex - 1].sortOrder
                        );
                      }}
                    >
                      ↑
                    </Button>
                  )}
                {changeOrderEnabled &&
                  blockItemsLength > 1 &&
                  blockItemIndex !== blockItemsLength - 1 && (
                    <Button
                      onClick={(e) => {
                        e.stopPropagation();
                        moveListItem(
                          blockItem.sortOrder,
                          blockItems[blockItemIndex + 1].sortOrder
                        );
                      }}
                    >
                      ↓
                    </Button>
                  )}
              </div>
              <div className={cn(styles.itemsWrapper)}>
                <div className={cn(styles.itemWrapper)}>
                  <Label content="Image" bold />
                  <Icon imageUrl={blockItem.imageUrl ?? ''} alt="Image block" />
                </div>
                <div className={cn(styles.itemWrapper)}>
                  <Label content="Background Image" bold />
                  <Icon
                    imageUrl={blockItem.backgroundImageUrl ?? ''}
                    alt="Image block"
                  />
                </div>
                <div className={cn(styles.itemWrapper)}>
                  <Label content="Background Color" bold />
                  <Icon color={blockItem.backgroundColor ?? ''} />
                </div>
              </div>

              <div className={styles.crudActions}>
                <Action
                  type="edit"
                  onClick={() => handleEdit(id, blockItem.type)}
                />
                <Action type="delete" onClick={() => handleDelete(id)} />
              </div>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </ListGroup.Item>
  );
};

export default SortableImageBlockItem;
